import React from "react";
import { getFeedback } from "../../../services/moodle/courses";
import { useAuth } from "../../../contexts/AuthContext";
import { useTheme } from "../../../contexts/ThemeContext";

export const ProgressRowItemDetail = ({ detail, includeFeedback }) => {
  const [feedback, setFeedback] = React.useState("-");
  const [generalFeedback, setGeneralFeedback] = React.useState("-");

  const theme = useTheme();
  const { user } = useAuth();

  React.useEffect(() => {
    if (
      detail.itemmodule === "quiz" &&
      detail.graderaw &&
      detail.iteminstance
    ) {
      const args = {
        token: user.token,
        quizid: detail.iteminstance,
        grade: detail.graderaw,
      };
      // console.log("getting feedback of: ", detail);
      getFeedback(args).then((res) => {
        if (res.feedbacktext !== "") {
          setGeneralFeedback(res.feedbacktext);
          // console.log("setting feedback");
        }
      });
    } else {
      if (detail.feedback !== "" && feedback === "-") {
        setFeedback(detail.feedback);
      }
    }
    // console.log({ indexMediaTag, index, feedback: detail.feedback });
    //eslint-disable-next-line
  }, []);

  return (
    <>

      <tr>
        <th
          className="p-4 "
          style={{
            borderColor: theme.colors.backgroundColorNotCurrentModule,
          }}
        >
          <p style={{ color: theme.colors.textColorDefault }}>
            {detail.itemname}
          </p>
        </th>
        <td
  className="p-4"
  style={{ 
    borderColor: theme.colors.backgroundColorNotCurrentModule,
  }}
>
  <div
    style={{ display: "inline-flex", alignItems: "center", gap: "0.25rem" }}
    dangerouslySetInnerHTML={{
      __html: detail.gradeformatted && detail.gradeformatted.split("(")[0]
    }}
  />
</td>
        <td
          className="p-4 "
          style={{ borderColor: theme.colors.backgroundColorNotCurrentModule }}
        >
          {detail.percentageformatted}
        </td>
        {includeFeedback && (
          <>
          <td
          className="p-4 "
          style={{ borderColor: theme.colors.backgroundColorNotCurrentModule }}
          dangerouslySetInnerHTML={{
            __html: feedback,
          }}
          ></td>
        <td
          className="p-4 "
          style={{ borderColor: theme.colors.backgroundColorNotCurrentModule }}
          dangerouslySetInnerHTML={{
            __html: generalFeedback,
          }}
          ></td>
          </>
        )}
      </tr>
    </>
  );
};
